import React from "react";

export default function QuizzProgressBar({ value = 0 }) {
  const safeValue = Math.min(100, Math.max(0, Number(value || 0)));

  return (
    <div className="h-3 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
      <div
        className="h-full rounded-full bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F] transition-[width] duration-300"
        style={{ width: `${safeValue}%` }}
      />
    </div>
  );
}